import React from "react";

/**
 * Generic top bar used across dashboards.
 * Left side: action buttons/links
 * Right side: filter controls/search/etc
 *
 * Usage:
 * <DashboardActionBar
 *   left={<YourButtons />}
 *   right={<YourFilters />}
 * />
 */
const DashboardActionBar = ({ left, right, className = "" }) => {
  return (
    <div
      className={
        "flex flex-col sm:flex-row items-center justify-between bg-gray-100 p-4 rounded-lg shadow-md " +
        className
      }
    >
      <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-2 items-stretch sm:items-center">
        {left}
      </div>

      <div className="flex flex-wrap gap-2 mt-2 items-center">
        {right}
      </div>
    </div>
  );
};

export default DashboardActionBar;
